import React, { PureComponent } from 'react'
import styled from 'styled-components'
import breakPoints from 'themes/breakPoints'
import { Container, Row, Col } from 'reactstrap'
import YouTubePlayer from 'react-player/lib/players/YouTube'
import TrackVisibility from 'react-on-screen'

const Section = styled.section`
  @media (min-width: ${breakPoints.lg.min}px) {
    background: url('/img/bg/bg-3.svg');
    background-size: cover;
    padding: 80px 0;
    position: relative;
  }
`

const VideoContainer = styled.div`
  position: relative;
  img {
    position: absolute;
    top: 56px;
    right: -24px;
  }
`

const Video = styled(TrackVisibility)`
  margin: 56px 0;
  border-radius: 8px;
  overflow: hidden;
`

export default class VideoComponent extends PureComponent {
  render () {
    return (
      <Section>
        <Container>
          <Row>
            <Col lg={{ size: 10, offset: 1 }}>
              <VideoContainer>
                <img src='/img/home-page/why-choose/video.svg' alt='video' />
                <Video>
                  {({ isVisible }) => (
                    <YouTubePlayer
                      width='100%'
                      height={500}
                      url={this.props.data}
                      playing={isVisible}
                    />
                  )}
                </Video>
              </VideoContainer>
            </Col>
          </Row>
        </Container>
      </Section>
    )
  }
}
